import { useEffect, useState } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  category: {
    fontWeight: "bold",
    opacity: "1 !important",
  },
  selectFlex: {
    "& .MuiSelect-select": {
      display: "flex",
    },
  },
}));

const defaultScorecardType = {
  label: "Other",
  sort: 999999,
};

export default function ScorecardPicker({
  label,
  name,
  value,
  handleChange,
  scorecards,
  touched,
  error,
  clearable,
  clearLabel,

  inclAny,
  anyLabel,
  open,
  setOpen,
  disabled,
  required,
  formControlSX,
  endAdornment,
  onClick,

  ...rest
}) {
  const classes = useStyles();
  const [items, setItems] = useState([]);

  var selectOptions = {};
  if (open !== undefined && open !== null) {
    selectOptions.open = open;
    selectOptions.native = false;
  }
  if (setOpen !== undefined && setOpen !== null) {
    selectOptions.onOpen = () => setOpen(true);
    selectOptions.onClose = () => setOpen(false);
  }

  var selectSX = {};
  if (endAdornment) {
    selectSX["& .MuiSelect-icon"] = {
      position: "relative",
      marginLeft: "-32px",
      left: "10px",
    };
  }

  useEffect(() => {
    const check = async () => {
      var itemArray = [];
      if (scorecards) {
        let _scorecards = [...scorecards];
        for (let scorecard of _scorecards) {
          // cleanup scorecard data
          if (scorecard.scorecardType === undefined) {
            scorecard.scorecardType = defaultScorecardType;
          }
          if (scorecard.scorecardType.label === undefined) {
            scorecard.scorecardType.label = defaultScorecardType.label;
          }
          if (scorecard.scorecardType.sort === undefined) {
            scorecard.scorecardType.sort = defaultScorecardType.sort;
          }
        }
        _scorecards.sort((a, b) => {
          if (a.scorecardType?.sort && !b.scorecardType?.sort) return -1;
          if (!a.scorecardType?.sort && b.scorecardType?.sort) return 1;
          if (a.scorecardType?.sort < b.scorecardType?.sort) return -1;
          if (a.scorecardType?.sort > b.scorecardType?.sort) return 1;

          var labelA = a.scorecardType?.label?.toLowerCase();
          var labelB = b.scorecardType?.label?.toLowerCase();
          if (labelA > labelB) return 1;
          if (labelA < labelB) return -1;

          var nameA = a.label?.toLowerCase();
          var nameB = b.label?.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        });
        let scorecardType = undefined;

        for (let scorecard of _scorecards) {
          if (
            scorecard.scorecardType.sort !== scorecardType?.sort ||
            scorecard.scorecardType.label !== scorecardType?.label
          ) {
            scorecardType = scorecard.scorecardType;
            itemArray.push(
              <MenuItem disabled value="" className={classes.category}>
                {scorecardType.label}
              </MenuItem>
            );
          }
          itemArray.push(
            <MenuItem key={scorecard.value} value={scorecard.value}>
              {scorecard.label}
            </MenuItem>
          );
        }
      }
      setItems(itemArray);
    };
    check();
    // eslint-disable-next-line
  }, [scorecards]);

  if (!scorecards) {
    return (
      <TextField
        label={label || "Scorecard"}
        value="...loading"
        variant="outlined"
        fullWidth
        disabled
        {...rest}
      />
    );
  }

  return (
    <FormControl
      fullWidth
      variant="outlined"
      className={classes.formControl}
      required={required}
      sx={{ ...formControlSX }}
      onClick={onClick}
      {...rest}
    >
      <InputLabel id={`${name}-label`}>{label || "Scorecard"}</InputLabel>
      <Select
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        labelId={`${name}-label`}
        name={name}
        value={value}
        onChange={(e) => {
          handleChange(e);
          if (setOpen) {
            setOpen(false);
          }
        }}
        label={label || "Scorecard"}
        variant="outlined"
        disabled={disabled}
        endAdornment={endAdornment}
        {...selectOptions}
        sx={selectSX}
        {...rest}
      >
        {clearable && (
          <MenuItem value="">
            <em>{clearLabel || "Clear"}</em>
          </MenuItem>
        )}
        {items &&
          items.map((item) => {
            return item;
          })}
      </Select>
      {Boolean(touched && error) && (
        <FormHelperText error>{error}</FormHelperText>
      )}
    </FormControl>
  );
}
